const EMAIL_OR_PHONE = 'emailorphone';
const USER_PROVIDED_USERNAME = 'user-provided-username';
const FLOW_PARAM = 'flow';
const REDIRECT_URL_PARAM = 'redirect-url';
const USERNAME = 'email';
const RESULT_URL = 'result_url';
const LAST_NAME = 'last-name';
const DOB = 'dob';
const POSTCODE = 'postcode';
const BROWSER_BACK = 'browser-back';

export {
  USER_PROVIDED_USERNAME,
  EMAIL_OR_PHONE,
  FLOW_PARAM,
  REDIRECT_URL_PARAM,
  RESULT_URL,
  USERNAME,
  LAST_NAME,
  DOB,
  POSTCODE,
  BROWSER_BACK,
};
